import { getIntersects } from './intersections/get-intersects.js';
import { Vector3 } from '../../src/js/three.module.js';

export const adjustPointToHeight = (() => {

	var downVector   = new Vector3( 0, -1 );
	var liftedPoint  = new Vector3();
	var liftTreshold = 0.1;

	return ( point, height, target ) => {

		// Nostetaan klikkauspistettä, jottei vahingossa lattiaa klikattaessa jouduta numeroiden epätarkkuuuksien takia alakerran katonrajaan katsomaan "alaspäin"
		liftedPoint.copy( point );
		liftedPoint.y += liftTreshold;
	
		var intersects = getIntersects( liftedPoint, downVector ), floor;

		for (var i in intersects) {
			
			var intr = intersects[i];

			// Hyväksyttävällä intersectilla pitää olla objekti ja face, eikä se saa olla skybox
			if (!(!intr.object || !intr.face || intr.object.userData.isSkybox)) {

				floor = intr;
				break;
			}
		}

		// @TODO: Tarkista, onko edes lattia!

		if (floor) {

			var deltaY = height - floor.distance + liftTreshold;

			target = target || new Vector3();

			target.copy( point );

			target.y += deltaY;

			return target;
		}
	}
})();
